export default {"src":"/_next/static/media/send.f32320ee.svg","height":19,"width":24};